import { http } from '@/api/client/httpClient';
import type { Select2Option } from '@/components/forms/Select2';
import type { ChartJsDataDto } from '@/api/services/riskDashboard';
import type { ClientProfitabilityFilterInput } from '@/api/types/riskDashboard';
import type {
  ClientProfitabilityTablePageDto,
  ClosedTradeDto,
  DealDto,
  OpenPositionDto,
} from '@/api/types/clientProfitability';

const BASE = '/api/app/client-profitability';

interface Paginated<T> {
  items: T[];
  totalCount: number;
}

export const clientProfitabilityApi = {
  // Main table — routes by Live × By-Unique-Id.
  async getMain(
    input: ClientProfitabilityFilterInput,
    opts: { live: boolean; byUniqueId: boolean },
  ): Promise<ClientProfitabilityTablePageDto> {
    const path = `${opts.live ? 'live' : 'history'}-by-${opts.byUniqueId ? 'uid' : 'login'}`;
    const { data } = await http.get<ClientProfitabilityTablePageDto>(`${BASE}/${path}`, { params: input });
    return data;
  },

  async getHistoryTrades(input: ClientProfitabilityFilterInput): Promise<Paginated<ClosedTradeDto>> {
    const { data } = await http.get<Paginated<ClosedTradeDto>>(`${BASE}/history-trades`, { params: input });
    return data;
  },
  async getTodayTrades(input: ClientProfitabilityFilterInput): Promise<Paginated<OpenPositionDto>> {
    const { data } = await http.get<Paginated<OpenPositionDto>>(`${BASE}/today-trades`, { params: input });
    return data;
  },
  async getDeals(input: ClientProfitabilityFilterInput): Promise<Paginated<DealDto>> {
    const { data } = await http.get<Paginated<DealDto>>(`${BASE}/deals`, { params: input });
    return data;
  },

  async getFirmNetPnlChartData(input: ClientProfitabilityFilterInput): Promise<ChartJsDataDto> {
    const { data } = await http.get<ChartJsDataDto>(`${BASE}/firm-net-pnl-chart-data`, { params: input });
    return data;
  },

  async getSwapStatuses(): Promise<Select2Option[]> {
    const { data } = await http.get<{ value: string | number; text: string }[]>(`${BASE}/swap-statuses`);
    return (data ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
};
